import React, { Component } from "react";
import { connect } from "react-redux";

import L from "leaflet";
import "./index.css";

const defaultCenter = [-37.814, 144.96332];

class ObservationSelectorMap extends Component {
  componentDidMount = () => {
    this.initMap();
  };

  componentWillUnmount = () => {
    if (this.state.map !== undefined) {
      this.state.map.remove();
    }
  };

  initMap = () => {
    const basemap = L.map("observationSelectioMap").setView(defaultCenter, 13);

    //Setting the base layer for the map
    L.tileLayer("https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png", {
      attribution:
        "&copy; <a href=\"http://www.openstreetmap.org/copyright\">OpenStreetMap</a> &copy; <a href=\"http://cartodb.com/attributions\">CartoDB</a>",
      subdomains: "abcd",
      maxZoom: 19
    }).addTo(basemap);

    const marker = L.marker(defaultCenter, { draggable: true }).addTo(basemap);

    //get the marker details on drag event
    marker.on("dragend", () => {
      const position = marker.getLatLng();
      marker
        .setLatLng(position, {
          draggable: "true"
        })
        .update();

      const location = {
        latitude: position.lat,
        longitude: position.lng
      };
      this.props.selectedLocationPoint(location);
    });

    // set the map object
    this.setState(() => {
      return {
        map: basemap
      };
    });
  };

  render() {
    return (
      <div>
        <div id="observationSelectioMap" />
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { user } = state.authentication;
  return {
    user
  };
}

export default connect(
  mapStateToProps,
  {}
)(ObservationSelectorMap);



// WEBPACK FOOTER //
// ./src/_components/ObservationSelectorMap/index.js